import { Box } from '@mui/material';
import { FC } from 'react';

import { observer } from 'mobx-react-lite';
import { UserData } from '@codefluegel/wowis-rest-typescript-client';
import CardContainer from '../../components/cards/CardContainer';
import useMedia from '../../hooks/useMedia';
import OnlineBillingCard from '../../components/cards/OnlineBillingCard';

interface Props {
  user: UserData | undefined;
}

const InvoiceData: FC<Props> = observer(props => {
  const { user } = props;
  const isMobile = useMedia('md');

  const title = 'Online-Zustellung';
  return (
    <Box height={1} width={1} p={1}>
      <CardContainer
        title={title}
        customStyle={{
          sx: {
            height: isMobile ? 1 : 'auto',
            minHeight: isMobile ? 1 : '15vh',
            margin: 0,
          },
        }}
        iconOn
        iconName={title}
      >
        <OnlineBillingCard onlineBilling={user?.onlineBilling} />
      </CardContainer>
    </Box>
  );
});

export default InvoiceData;
